import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BalanceQuery, config, MemberCard, MemberCardQuery, MemberDetails, MemberQuery, PopulationQuery } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { Observable } from 'rxjs';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-home-nav',
  templateUrl: './home-nav.component.html',
  styleUrl: './home-nav.component.scss',
})
export class HomeNavComponent implements OnInit, AfterViewInit {
  screenType = ScreenType;
  card$: Observable<MemberCard | undefined>;
  memberDetails$: Observable<MemberDetails | undefined>;
  ecash$: Observable<number | undefined>;
  pointsBalance$: Observable<number | undefined>;
  population = Populations;
  isKid: boolean;

  @ViewChild('scrollContainer', { static: true })
  scrollContainer!: ElementRef<HTMLDivElement>;

  constructor(
    private balanceQuery: BalanceQuery,
    private memberCardQuery: MemberCardQuery,
    private memberQuery: MemberQuery,
    private populationQuery: PopulationQuery
  ) {}

  ngOnInit() {
    this.card$ = this.memberCardQuery.selectCurrentCard();
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.ecash$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
    this.pointsBalance$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.isKid = this.populationQuery.userInPopulation(['Kids']);
  }

  ngAfterViewInit() {
    const el = this.scrollContainer.nativeElement.querySelector('.navigation-row') as HTMLElement;

    el.addEventListener('scroll', () => {
      const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
      if (atEnd) {
        this.scrollContainer.nativeElement.classList.add('at-end');
      } else {
        this.scrollContainer.nativeElement.classList.remove('at-end');
      }
    });
  }
}
